import { Component, Input } from '@angular/core';
import { IDataConfirmTransactionComponent } from '@pacifico/interfaces/components.interface';

@Component({
	selector: 'app-confirm-transaction',
	templateUrl: './confirm-transaction.component.html',
	styleUrls: ['./confirm-transaction.component.scss']
})
export class ConfirmTransactionComponent {
	@Input() dataTransfer!: IDataConfirmTransactionComponent;
}
